import React from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import ErrorReport from "../ErrorReport"
import PropTypes from "prop-types"
import NotFound from "../../routes/NotFound"

// Skeleton from https://reactjs.org/blog/2017/07/26/error-handling-in-react-16.html
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentWillReceiveProps() {
    // Clear errors on state change.
    this.setState({ hasError: false })
  }

  componentDidCatch(error, info) {
    const authError =
      error.networkError && error.networkError.statusCode === 401
    const notFoundError = error.message === "404"
    this.setState({
      hasError: true,
      authError: authError,
      notFoundError: notFoundError,
    })
    /* istanbul ignore next */
    if (
      process.env.NODE_ENV === "production" &&
      !(authError || notFoundError)
    ) {
      window.Raven.captureException(error, {
        extra: info,
      })
    }
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children
    }
    if (this.props.errorComponent) {
      return React.createElement(this.props.errorComponent, this.props)
    }
    if (this.state.notFoundError) {
      return <NotFound />
    }
    if (this.state.authError) {
      return (
        <ErrorReport
          title="You are not yet logged in"
          subtitle="You should be redirected momentarily. If you are not, please click the button below."
        >
          <Link
            className="btn btn-primary"
            to={process.env.REACT_APP_AUTH_DOMAIN + "/users/sign_in"}
          >
            Login here
          </Link>
        </ErrorReport>
      )
    }
    return (
      <ErrorReport
        title="Oh no! Something went wrong."
        subtitle="Hang tight - our engineers have been notified and are working on a resolution."
      />
    )
  }
}

ErrorBoundary.propTypes = {
  errorComponent: PropTypes.func,
  children: PropTypes.node,
}

export default connect(({ router }) => ({
  location: router.location,
}))(ErrorBoundary)
